import { render, staticRenderFns } from "./SendOrder.vue?vue&type=template&id=153cdb1b&"
import script from "./SendOrder.vue?vue&type=script&lang=js&"
export * from "./SendOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports